// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Choice-module__ui-Choice--vUoxl {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  border-bottom: 1px solid var(--chaek-color-border-divider);
}

.Choice-module__ui-Choice-Option--XQMmJ {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 2px solid transparent;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
}

.Choice-module__distribution-equal--G3sBs {
  height: 39px;
  align-items: flex-start;
  gap: 4px;
  padding: 0;
}

.Choice-module__distribution-equal--G3sBs .Choice-module__ui-Choice-Option--XQMmJ {
  min-width: 1px;
  min-height: 38px;
  height: 100%;
  flex: 1 0 0;
  padding: 0 2px;
  color: var(--chaek-color-text-muted);
  font-size: 12px;
  line-height: 18px;
}

.Choice-module__distribution-content--YP_fM {
  height: 45px;
  align-items: center;
  gap: 24px;
  padding: 0 22px;
}

.Choice-module__distribution-content--YP_fM .Choice-module__ui-Choice-Option--XQMmJ {
  height: 44px;
  flex: 0 0 auto;
  padding: 0 12px;
  color: var(--chaek-color-text-inactive);
  font-size: 14px;
  letter-spacing: -0.1504px;
  line-height: 21px;
}

.Choice-module__ui-Choice-Option--XQMmJ.Choice-module__is-active--E6U5_ {
  border-bottom-color: var(--chaek-color-border-strong);
  color: var(--chaek-color-text-primary);
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Choice/Choice.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,0DAA0D;AAC5D;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,uCAAuC;EACvC,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;EACrD,sCAAsC;AACxC","sourcesContent":[".ui-Choice {\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  border-bottom: 1px solid var(--chaek-color-border-divider);\n}\n\n.ui-Choice-Option {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-bottom: 2px solid transparent;\n  font-weight: 400;\n  text-align: center;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.distribution-equal {\n  height: 39px;\n  align-items: flex-start;\n  gap: 4px;\n  padding: 0;\n}\n\n.distribution-equal .ui-Choice-Option {\n  min-width: 1px;\n  min-height: 38px;\n  height: 100%;\n  flex: 1 0 0;\n  padding: 0 2px;\n  color: var(--chaek-color-text-muted);\n  font-size: 12px;\n  line-height: 18px;\n}\n\n.distribution-content {\n  height: 45px;\n  align-items: center;\n  gap: 24px;\n  padding: 0 22px;\n}\n\n.distribution-content .ui-Choice-Option {\n  height: 44px;\n  flex: 0 0 auto;\n  padding: 0 12px;\n  color: var(--chaek-color-text-inactive);\n  font-size: 14px;\n  letter-spacing: -0.1504px;\n  line-height: 21px;\n}\n\n.ui-Choice-Option.is-active {\n  border-bottom-color: var(--chaek-color-border-strong);\n  color: var(--chaek-color-text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-Choice": `Choice-module__ui-Choice--vUoxl`,
	"ui-Choice-Option": `Choice-module__ui-Choice-Option--XQMmJ`,
	"distribution-equal": `Choice-module__distribution-equal--G3sBs`,
	"distribution-content": `Choice-module__distribution-content--YP_fM`,
	"is-active": `Choice-module__is-active--E6U5_`
};
export default ___CSS_LOADER_EXPORT___;
